import React from 'react'
import { Link } from 'gatsby'
import { STANDARD_PRICE } from './CurrencyContext'
import './plan-cards.scss'

const PlanCards = ({ currency, trackingPrefix }) => {
    const standardPrice = STANDARD_PRICE[currency]

    const trackCta = (plan, action) => (trackingPrefix ? {
        'data-track': 'cta',
        'data-cta-id': `${trackingPrefix}_${plan}_${action}`,
        'data-cta-location': 'plan_card',
        'data-cta-destination': 'signup',
        'data-plan': plan,
    } : {})

    return (
        <div className="plan-card-container">
            <div className="plan-card free-plan-card">
                <div className="plan-card-info-container">
                    <div className="plan-card-text-container">
                        <div className="plan-card-description-container">
                            <div className="plan-card-title-container">
                                <h3 className="plan-card-title-text">Free</h3>
                                <p className="plan-card-subtitle-text">Getting started</p>
                            </div>
                            <p className="plan-card-body-text">For small teams getting started and creating structure</p>
                        </div>
                        <div className="plan-card-price-container">
                            <p className="plan-card-price-text">$0</p>
                            <p className="plan-card-unit-text">per user</p>
                        </div>
                    </div>
                    <div className="plan-card-button-container">
                        <Link to="/signup/" className="plan-card-button" {...trackCta('free', 'start_free')}>Start Free</Link>
                        <p className="plan-card-note-text">Forever free. No credit card. No contract.</p>
                    </div>
                    <div className="plan-card-feature-container">
                        <p className="plan-card-feature-header-text">Free includes:</p>
                        <ul className="plan-card-feature-list">
                            <li><img src="/app-icons/checkmark.svg" alt="" />All Workhub Foundation Components</li>
                            <li><img src="/app-icons/checkmark.svg" alt="" />Training &amp; Certification</li>
                            <li><img src="/app-icons/checkmark.svg" alt="" />Incident Tracking &amp; Form Management</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="plan-card standard-plan-card">
                <div className="standard-plan-recommended-container">
                    <p className="standard-plan-recommended-text">RECOMMENDED</p>
                </div>
                <div className="plan-card-info-container">
                    <div className="plan-card-text-container">
                        <div className="plan-card-description-container">
                            <div className="plan-card-title-container">
                                <h3 className="plan-card-title-text">Standard</h3>
                                <p className="plan-card-subtitle-text">Confidence at scale</p>
                            </div>
                            <p className="plan-card-body-text">For growing organizations who want compliance that actually works</p>
                        </div>
                        <div className="plan-card-price-container">
                            <p className="plan-card-price-text">${standardPrice}</p>
                            <p className="plan-card-unit-text">per user/month</p>
                        </div>
                    </div>
                    <div className="plan-card-button-container">
                        <Link to="/signup/" className="plan-card-button standard-plan-button" {...trackCta('standard', 'start_trial')}>Start Trial</Link>
                        <p className="plan-card-note-text">Try free for 30 days. Then ${standardPrice}/month.</p>
                    </div>
                    <div className="plan-card-feature-container">
                        <p className="plan-card-feature-header-text">All Free features, and:</p>
                        <ul className="plan-card-feature-list">
                            <li><img src="/app-icons/checkmark.svg" alt="" />Advanced Reporting</li>
                            <li><img src="/app-icons/checkmark.svg" alt="" />Onboarding &amp; Priority Support</li>
                            <li><img src="/app-icons/checkmark.svg" alt="" />Role-Based Access Control</li>
                            <li><img src="/app-icons/plus.svg" alt="" />and more...</li>
                        </ul>
                        <p className="standard-plan-minimum-text">*Minimum 3 users</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PlanCards